import { useCallback } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import MaldivesBanner from 'components/MaldivesDirect/MaldivesBanner'
import { useMaldivesBannerPrice } from 'components/MaldivesDirect/useMaldivesBannerPrice'
import { CHARTER_PAGE_SLUG, MALDIVES_BUNDLE_DEFAULT_NIGHTS, MALDIVES_FLIGHTS_LANDING_CAMPAIGN_NAME } from 'constants/charterFlight'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import { pushWithRegion } from 'actions/NavigationActions'

const MALDIVES_BANNER_DEFAULT_ROOMS: Array<App.Occupants> = [{ adults: 2, children: 0, infants: 0 }]

const MaldivesBannerContainer = styled(LayoutContainer)`
  padding-block-start: ${rem(24)};
  padding-block-end: ${rem(24)};
`

function FlightsSearchMaldivesBundlesBanner() {
  const dispatch = useAppDispatch()
  const luxPlusEnabled = useAppSelector(getIsLuxPlusEnabled)
  const { maldivesBundlePrice, isMaldivesBundlePriceLoading } = useMaldivesBannerPrice({
    enabled: true,
    nights: MALDIVES_BUNDLE_DEFAULT_NIGHTS,
    rooms: MALDIVES_BANNER_DEFAULT_ROOMS,
    useMemberPrice: luxPlusEnabled,
  })

  const handleViewBundlesClick = useCallback(() => {
    dispatch(pushWithRegion(`/campaign/${CHARTER_PAGE_SLUG}`))
  }, [dispatch])

  return (
    <MaldivesBannerContainer>
      <MaldivesBanner
        onViewBundlesClick={handleViewBundlesClick}
        price={maldivesBundlePrice}
        nights={MALDIVES_BUNDLE_DEFAULT_NIGHTS}
        isPriceLoading={isMaldivesBundlePriceLoading}
        promotionName={MALDIVES_FLIGHTS_LANDING_CAMPAIGN_NAME}
      />
    </MaldivesBannerContainer>
  )
}

export default FlightsSearchMaldivesBundlesBanner
